import { Project } from '@dc-shared-web/hooks/api/project/types'
import { AxiosInstance } from 'axios'

export type MoveProjectParams = {
  uuid: string
  parent_uuid: string
  office_uuid: string
}

export const moveProject = async (
  apiClient: AxiosInstance,
  params: MoveProjectParams
): Promise<Project> => {
  const parent_uuid =
    params.parent_uuid === 'dashboard' ? null : params.parent_uuid
  const {
    data: { data },
  } = await apiClient.patch(`/api/project-info/${params.uuid}`, {
    parent_uuid: parent_uuid,
    office_uuid: params.office_uuid,
  })

  return data
}
